module.exports = __webpack_public_path__ + "img/stripe-powered.86909417.png";